import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  startAdornment: {
    '&&': {
      fontSize: '12px',
      fontWeight: 700,
      color: theme.palette.custom.grey2,
      marginRight: '8px',
    },
  },
}))
